<template>
    <div class="lWrap"
         v-loading.fullscreen.lock="loading"
         :element-loading-text="loadingText"
         element-loading-custom-class="dgmong_loading">
        <page-header
                v-if="passPath.indexOf($route.path) === -1 && hasUserInfo()"
        >
        </page-header>
        <router-view/>
    </div>
</template>

<script>
    import localStorage from './mixins/localStorage'
    import {setAuthInHeader} from "@/api/request";
    import {mapState, mapGetters} from "vuex"
    import util from "@/mixins/util";
    import EventBus from "@/mixins/event-bus";

    export default {
        name: "App",
        mixins: [ localStorage ],
        provide() {
            return{
                changeLoading: this.changeLoading,
            }
        },
        data() {
            return {
                passPath: ['/auth/regist', '/auth/findid', '/auth/findpassword', '/auth'],
                loading: false,
                loadingText: '',
            }
        },
        created(){
          let token = this.$localStorage.get('token');
          if(token){
            this.$route.query.token = '';
            setAuthInHeader(token);
            this.UpdateSiteCheck();
            this.UpdateUserCheck('');
            if (!this.parcelListIsGet) {
              this.$store.dispatch('parcelCompany/setParcelList', {});
            }
          }else if(this.$route.path === '/policy'){

          }else{
            this.$router.push('/auth');
          }

        },
        mounted() {
            EventBus.$on('changeLoading', this.changeLoading)
        },
        beforeDestroy() {
            EventBus.$off('changeLoading', this.changeLoading)
        },
        computed: {
            ...mapState({
                UserInfo: state => state.userInfo.UserInfo,
                parcelListIsGet: status =>status.parcelList
            })
        },
        methods: {
            hasUserInfo() {
                return !util.isEmpty(this.UserInfo)
            },
            changeLoading(value, text='') {
                this.loading = value;
                if(!value) {
                    this.loadingText = '';
                }else{
                    this.loadingText = text;
                }
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        resolve(true);
                    }, 50)
                })
            },
        }
    }
</script>

<style lang="scss">
    @import "./assets/scss/index.scss";
</style>

